import { useEffect, useContext } from "react";
import { VALIDATION_STATE } from "./useValidation";
import { FormContext } from "../components/input/FormContext";
export function useForm(inputId, validity, value, resetValidation, scrollToRef, errorMessages, label) {
    const context = useContext(FormContext);
    const updateInput = context === null || context === void 0 ? void 0 : context.updateInput;
    const removeInput = context === null || context === void 0 ? void 0 : context.removeInput;
    useEffect(() => {
        const id = inputId;
        updateInput === null || updateInput === void 0 ? void 0 : updateInput({
            id,
            isValid: validity === VALIDATION_STATE.SUCCESS,
            isInvalid: validity !== VALIDATION_STATE.SUCCESS,
            validationState: validity,
            value,
            resetValidation,
            scrollToRef,
            errorMessages,
            label,
        });
        return () => {
            removeInput === null || removeInput === void 0 ? void 0 : removeInput(id);
        };
    }, [
        updateInput,
        removeInput,
        inputId,
        validity,
        value,
        resetValidation,
        scrollToRef,
        errorMessages,
        label,
    ]);
}
